import React, { useState, useEffect } from "react";

const symptomsList = [
    "Dolor de cabeza",
    "Fiebre alta",
    "Tos seca",
    "Dolor muscular",
    "Fatiga excesiva",
    "Congestión nasal",
];

const InputSymptom = ({ onSymptomsChange }) => {
    const [symptom, setSymptom] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [selectedSymptoms, setSelectedSymptoms] = useState([]);

    useEffect(() => {
        onSymptomsChange(selectedSymptoms);
    }, [selectedSymptoms, onSymptomsChange]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSymptom(value);
        if (value.trim()) {
            const filtered = symptomsList.filter((s) =>
                s.toLowerCase().startsWith(value.toLowerCase())
            );
            setSuggestions(filtered);
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        setSymptom(suggestion);
        setSuggestions([]);
    };

    const handleAddSymptom = () => {
        if (!symptom.trim() || selectedSymptoms.includes(symptom)) return;
        setSelectedSymptoms([...selectedSymptoms, symptom]);
        setSymptom("");
        setSuggestions([]);
    };

    const handleRemoveSymptom = (s) => {
        setSelectedSymptoms(selectedSymptoms.filter((sym) => sym !== s));
    };

    return (
        <div>
            <input
                type="text"
                placeholder="Ingresa tus síntomas..."
                value={symptom}
                onChange={handleInputChange}
                style={{
                    width: "100%",
                    padding: "13px",
                    fontSize: "16px",
                    borderRadius: "25px",
                    border: "2px solid #ccc",
                    outline: "none",
                    marginBottom: "10px",
                }}
            />
            <button
                onClick={handleAddSymptom}
                style={{
                    width: "100%",
                    padding: "14px",
                    fontSize: "14px",
                    backgroundColor: "#007BFF",
                    color: "white",
                    border: "none",
                    borderRadius: "25px",
                    cursor: "pointer",
                    marginBottom: "10px",
                }}
            >
                Agregar síntoma
            </button>

            {suggestions.length > 0 && (
                <ul
                    style={{
                        listStyleType: "none",
                        padding: 0,
                        marginTop: 0,
                        maxHeight: "150px",
                        overflowY: "auto",
                        width: "100%",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        backgroundColor: "#f4f4f4",
                    }}
                >
                    {suggestions.map((s, i) => (
                        <li
                            key={i}
                            onClick={() => handleSuggestionClick(s)}
                            style={{
                                padding: "10px",
                                cursor: "pointer",
                                borderBottom: "1px solid #ccc",
                            }}
                        >
                            {s}
                        </li>
                    ))}
                </ul>
            )}

            <div
                style={{
                    marginTop: "15px",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                }}
            >
                {selectedSymptoms.map((s, i) => (
                    <div
                        key={i}
                        onClick={() => handleRemoveSymptom(s)}
                        style={{
                            padding: "8px 15px",
                            background: "#007bff",
                            color: "white",
                            borderRadius: "25px",
                            cursor: "pointer",
                            userSelect: "none",
                        }}
                        title="Click para eliminar"
                    >
                        {s} ✕
                    </div>
                ))}
            </div>
        </div>
    );
};

export default InputSymptom;
